export const DEFAULT_LIMIT = 25;
export const DEFAULT_OFFSET = 0;
export const JOBS_LIMIT = 10
export const EMPLOYMENT_FORM_LIMIT = 10
export const CV_LIMIT = 10
